import { BUSINESS_FUNDING_TYPE, BUSINESS_MODEL_TYPE } from './constants';

/**
 * Checks if the business model type is Deposit
 * @param {Business} business
 * @return {boolean}
 */
export const hasDepositModel = business => {
    return business?.model_type === BUSINESS_MODEL_TYPE.DEPOSIT;
};

/**
 * Checks if the business model type is Credit v1
 * @param {Business} business
 * @return {boolean}
 */
export const hasCreditModelV1 = business => {
    return business?.model_type === BUSINESS_MODEL_TYPE.CREDIT_V1;
};

/**
 * Checks if the business model type is Credit v2
 * @param {Business} business
 * @return {boolean}
 */
export const hasCreditModelV2 = business => {
    return business?.model_type === BUSINESS_MODEL_TYPE.CREDIT_V2;
};

/**
 * Checks if the business model type is Credit v1 or Credit v2
 * @param {Business} business
 * @return {boolean}
 */
export const hasCreditModel = business => {
    return business?.model_type === BUSINESS_MODEL_TYPE.CREDIT_V1 || business?.model_type === BUSINESS_MODEL_TYPE.CREDIT_V2;
};

/**
 * Checks if the business model type is PIN
 * @param {Business} business
 * @return {boolean}
 */
export const hasPINModel = business => {
    return business?.model_type === BUSINESS_MODEL_TYPE.PIN && business.business_ar_id;
};

/**
 * Checks if the business model type is Deposit or PIN
 * @param {Business} business
 * @return {boolean}
 */
export const hasPrepaidModel = business => {
    return hasDepositModel(business) || hasPINModel(business);
};

/**
 * Checks if the business funding type is credit line
 * @param {Business} business
 * @return {boolean}
 */
export const hasCreditLine = business => {
    return business?.funding_type === BUSINESS_FUNDING_TYPE.CREDIT_LINE;
};

/**
 * Checks if the business funding type is prefunding
 * @param {Business} business
 * @return {boolean}
 */
export const hasPrefunding = business => {
    return business?.funding_type === BUSINESS_FUNDING_TYPE.PREFUNDING;
};

/**
 * Checks if the business has available funds
 * @param {Business} business
 * @param {Object} statistics
 * @return {boolean}
 */
export const hasAvailableFunds = (business, statistics) => {
    if (hasCreditModel(business) && hasCreditLine(business) && statistics.creditAvailable > 0) {
        return true;
    }
    if (hasCreditModel(business) && hasPrefunding(business) && statistics.availableToAddtoCards > 0) {
        return true;
    }
    if (hasPrepaidModel(business) && statistics.availableToAddtoCards > 0) {
        return true;
    }
    return false;
};
